import React from 'react'

import { Button } from '@/components/buttons/Button'

export const DateRangePickerButtons = ({
  handleCancel,
  handleSave,
  cancelLabel,
  saveLabel,
  disabled,
  disabledMessage,
}) => {
  return (
    <div className="date-picker-button-section" data-testid="date-picker-button-section">
      <Button onClick={handleCancel} data-testid="cancel">
        {cancelLabel || 'Cancel'}
      </Button>
      <Button
        brand
        onClick={handleSave}
        data-testid="submit"
        disabled={disabled}
        disabledTooltip={disabledMessage}
      >
        {saveLabel || 'Save'}
      </Button>
    </div>
  )
}
